<script>
  import { onMount } from "svelte";
  /* Executable code section of the program */
  //Tools importation
  import { meetsArray, temporalData,lastMeetScheduled,eventRealTime } from "../apis/storage";

  //Components importation
  import MeetsCard from "./Cards/MeetsCard.svelte";
  import { getOneDocument } from "../apis/APIS";
  import { navigate } from "svelte-routing";

  //Auxiliary variables
  export let colorBtn 
  let dinamicMeets = [];

//  Función para traer reuniones por IDs desde Firestore
const fetchMeetsByIds = async (ids) => {
  if (!Array.isArray(ids) || ids.length === 0) return;
  
  try {
    const fetched = await Promise.all(
      ids.map((id) => getOneDocument("meetings", id))
    );

    let firtsArray = fetched.filter(Boolean); // elimina nulls si algún doc no existe
    firtsArray = firtsArray.filter(element=>element.event === $eventRealTime.tittle)
    $lastMeetScheduled = getLastAcceptedRegularMeet(firtsArray)
    const reversed = firtsArray.reverse(); //  Primero darle la vuelta
    const firstThree = reversed.slice(0, 3); //  Luego tomar los primeros 3
    dinamicMeets = firstThree
  } catch (err) {
    console.error("❌ Error fetching meetings:", err);
  }
};

//Funcion para obtener el ultimo Meet regular agendado
function getLastAcceptedRegularMeet(array) {
  if (!Array.isArray(array)) return [];

  // Recorre el array en reversa buscando el que cumpla ambas condiciones
  for (let i = array.length - 1; i >= 0; i--) {
    const item = array[i];
    if (item.meetType === "Regular" && item.meetStatus === "accepted") {
      return item;
    }
  }

  // Si no encuentra ninguno que cumpla
  return [];
}

//  Reacción automática cuando $meetsArray cambia
$: {
  if ($meetsArray?.length > 0) {
    fetchMeetsByIds($meetsArray);
  }
}



  /* End of the section */
</script>

<!-- Section to place the HTML code -->
{#if dinamicMeets.length > 0}
  <section class="principalContainer">
    {#each dinamicMeets as data }
        <MeetsCard cardContent= {data} colorBtn = {colorBtn}/>
    {/each}
  </section>
  <div class="btnSeeMore">
    <button class="actionBtn addEventBtn" on:click={()=>navigate(`/mymeets/${$temporalData.id}`)}>See More Meetings</button>
  </div>
{:else}
  <section class="emptyContent">
    <svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" fill="currentColor" class="bi bi-journal-bookmark-fill" viewBox="0 0 16 16">
        <path fill-rule="evenodd" d="M6 1h6v7a.5.5 0 0 1-.757.429L9 7.083 6.757 8.43A.5.5 0 0 1 6 8z"/>
        <path d="M3 0h10a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-1h1v1a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1H3a1 1 0 0 0-1 1v1H1V2a2 2 0 0 1 2-2"/>
        <path d="M1 5v-.5a.5.5 0 0 1 1 0V5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0V8h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1zm0 3v-.5a.5.5 0 0 1 1 0v.5h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1z"/>
      </svg>
    <p class="emptyText">There are no meetings scheduled for you in this event.</p>
  </section>
{/if}

<!-- End of the section -->
<style>
  /* Section to place the code styles */
  /* Principal styles */
  /* Empty styles */
  .emptyContent {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    width: 100%;
    height: 30vh;
    padding: 20px;
  }
  .emptyText{
    margin-top: 5px;
  }
  /* Container styles */
  .principalContainer {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
    height: auto;
    min-height: 30vh;
    background-color: #f4f4f4;
    padding: 20px;
  }
  /* Buttons section */
  .actionBtn {
    width: 30%;
    border-radius: 12px;
    font-size: 16px;
    font-weight: 500;
    padding: 8px 16px;
    background-color: white;
    color: #111;
    border: 1px solid #444;
    transition: all 0.3s ease-in-out;
    margin: 5px 20px;
  }

  .addEventBtn:hover {
    cursor: pointer;
    box-shadow: #000 0px 0px 5px;
    transform: scale(1.01);
    border-color: #fff;
    background-color: #ed2824;
    color: White;
  }
  .btnSeeMore {
    display: flex;
    justify-content: center;
    padding: 20px 0;
  }

  /* /////////Tablets///////// */
  @media (min-width: 700px) and (max-width: 1100px) {
  }
  /* /////////Cellphones ///////// */
  @media (max-width: 700px) {
    .actionBtn {
    width: 90%;
  }
  /* Empty styles */
  .emptyText{
    text-align: center;
  }
  }
  /* End of the section */
</style>
